/**
 * Opens SyncModal (Strava connect) when a bulk sync / fetch-streams SSE error means
 * the user should reconnect OAuth. Server sets `openConnectModal: true`; we also
 * match known English messages for older backends.
 * @param {{ type?: string, error?: string, openConnectModal?: boolean }} event
 */
export function maybeOpenStravaConnectModalFromSyncEvent(event) {
  if (!event || event.type !== 'error') return;
  if (event.openConnectModal === true) {
    window.dispatchEvent(new CustomEvent('openSyncModal'));
    return;
  }
  const msg = String(event.error || '');
  if (
    /reconnect Strava/i.test(msg) ||
    /^Strava not connected\.?$/i.test(msg.trim()) ||
    /athlete not found\. Please reconnect/i.test(msg)
  ) {
    window.dispatchEvent(new CustomEvent('openSyncModal'));
  }
}
